import type { OnboardingOfferKey } from "@/services/api-hooks/offers";

import { track } from "../track";
import { buildOfferAnalyticsBaseParams } from "./offerAnalyticsParams";

interface Params {
  offerKey: OnboardingOfferKey;
}

export const trackOfferSaleView = ({ offerKey }: Params) =>
  track({ event: "sale_view", ...buildOfferAnalyticsBaseParams(offerKey) });
